var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { getConfig, keysToCamelCase } from "@jti/fe-common";
import { getUser, sanitizeBaseUrl } from "../../utils";
import { storeCancellationRequest } from "../evo-client/__generated__";
import { createClient, createConfig } from "../evo-client/__generated__/client";
export class OrderCancellationApi {
    constructor() {
        this.name = "OrderCancellationApi";
        this.config = getConfig();
        this.user = getUser();
        const baseUrl = this.config.EVO_DOMAIN;
        this.commonHeaders = {
            "X-DES-TENANT": this.config.EVO_TENANT,
        };
        const clientConfig = createConfig({
            baseUrl: sanitizeBaseUrl(baseUrl),
        });
        this.client = createClient(clientConfig);
    }
    sendCancellationRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.user.uuid) {
                throw new Error("uuid is not defined");
            }
            const recaptchaToken = yield this.getRecaptchaToken();
            const response = yield storeCancellationRequest({
                client: this.client,
                throwOnError: true,
                headers: Object.assign(Object.assign({}, this.commonHeaders), { "X-DES-USER-TOKEN": this.user.ciam_token, "X-DES-RECAPTCHA-TOKEN": recaptchaToken }),
                body: data,
            });
            return keysToCamelCase(response.data);
        });
    }
    getRecaptchaToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const recaptchaId = this.config["X-RECAPTCHA-ID"];
            if (typeof recaptchaId !== "string") {
                console.warn("[OrderCancellationApi] Recaptcha ID is not a valid string, returning empty string instead.");
                return "";
            }
            return getGoogleReCaptchaToken(recaptchaId);
        });
    }
}
//# sourceMappingURL=orderCancellationApi.js.map